import { useFlags } from 'launchdarkly-react-client-sdk';
import React from 'react';

import YearAndMonthFilterLegacy from './_do_not_import_/YearAndMonthFilter';
import YearAndMonthFilterV2, { IYearAndMonthFilterProps } from './_do_not_import_v2_/YearAndMonthFilter';

export const YearAndMonthFilter = (props: IYearAndMonthFilterProps) => {
  const flags = useFlags<{ bookingViewV2: boolean }>();

  if (flags.bookingViewV2) {
    return <YearAndMonthFilterV2 {...props} />;
  }

  return <YearAndMonthFilterLegacy {...props} />;
};
